const Menu =  [
  { header: 'Apps' },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    dispatch:'fetchFriends'
  },
  { divider: true },
  {
    title: 'Membres',
    group: 'widgets',
    component: 'widgets',
    icon: 'widgets',
    dispatch:'fetchMembers',
    items: [
      { name: 'allmembers', title: 'Membres Total', component: 'components/widget-allmembers' , dispatch:'fetchMembers' },
      { name: 'statistic', title: 'Membres Aujourd\'hui', badge: 'new', component: 'components/widget-todaylist',  dispatch:'fetchMembers' },
      { name: 'chart', title: 'Serviteurs', component: 'components/widget-serviteurs' , dispatch:'fetchMembers' },
      { name: 'list', title: 'Donnés Vides', component: 'components/widget-empty-list' , dispatch:'fetchMembers' },
      { name: 'referrals', title: 'Références', component: 'components/widget-referrals' , dispatch:'fetchMembers' },
      { name: 'search', title: 'Recherche', component: 'components/widget-search'  , dispatch:'fetchMembers' },
     
    ]
  },
  { header: 'Community' },
  {
    title: 'Chat',
    group: 'apps',
    icon: 'chat_bubble',
    name: 'widget-chat',
    dispatch:'fetchConvos'
  }, 
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu_employee.js